<h3 class="mr-3">Title insurance</h3>
<div class="flex justify-center mb-10">
	<div class="flex flex-col items-center">
		<div class="flex w-32 h-32">
			<img src="{{ companyLogo }}" />
		</div>
		<div class="flex gap-2 items-center">
			<app-icon [icon]="ICON.CLIP_BOARD" class="text-lg"></app-icon>
			<span class="text-lg font-bold">Manual entry</span>
		</div>
		<span
			class="text-sm text-green underline cursor-pointer mb-3"
			(click)="switchToIntegrated()"
			[testHook]="testHooks.SwitchToIntegratSpan"
		>
			<ng-container
				*ngIf="
					(propertyType$ | async)?.usage === propertyUsage.RESIDENTIAL;
					else commercialText
				"
			>
				Switch to integrated provider
			</ng-container>
			<ng-template #commercialText> Switch provider </ng-template>
		</span>
		<app-title-insurance-toolbar
			[provider]="titleInsuranceProvider.MANUAL"
			[orderValid]="true"
			[company]="company"
			(cancelOrder)="clear()"
		></app-title-insurance-toolbar>
	</div>
</div>
